import { Pipe, PipeTransform } from '@angular/core';
import { UserStatusReason } from '@lib/interfaces';

@Pipe({
    name: 'passportVerificationStatus',
    standalone: true,
})
export class PassportVerificationStatusPipe implements PipeTransform {
    transform(status: string): string {
        switch (status) {
            case UserStatusReason.A1I:
                return 'Under Review';
            case UserStatusReason.A3:
                return 'Verified';
            case UserStatusReason.A1R:
                return 'Rejected';
            default:
                return 'N/A';
        }
    }
}
